import { useCallback, useEffect, useState } from "react";
import axios from "axios";
import {
  Grid,
  Box,
  Typography,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Button,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  TextField,
  FormControlLabel,
  Checkbox,
  IconButton,
  Tooltip
} from "@mui/material";
import ContentCopyIcon from "@mui/icons-material/ContentCopy";
import { withStyles } from "@material-ui/core/styles";
import styles from "./fnoStyles";
import { FormControl, InputLabel, MenuItem, Modal, Select } from "@material-ui/core";
import CloseIcon from "@mui/icons-material/Close";
import { Download } from "@mui/icons-material";
import Swal from "sweetalert2";
import { DataGrid } from "@mui/x-data-grid";
import EditIcon from "@mui/icons-material/Edit";
import { DatePicker, LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import dayjs from "dayjs";
import { backendHosts,apiUrl } from '../../../../../ui-utils/apiConfig'


const Fno = ({ classes }) => {
    const [requests, setRequests] = useState([]);
    const [open, setOpen] = useState(false);
    const [selectedRow, setSelectedRow] = useState(null);
    const [paginationModel, setPaginationModel] = useState({
        pageSize: 10,
        page: 0,
    });

  const [Fdate, setFdate] = useState(dayjs().subtract(3, 'month').startOf('month'));
  const [Tdate, setTdate] = useState(dayjs());
  const [fterror, setFTError] = useState("")
  const [status, setStatus] = useState('Pending')

  const username = localStorage.getItem('username')

    useEffect(() => {
      const today = dayjs();
      const threeMonthsAgo = today.subtract(3, 'month').startOf('month');

      setFdate(threeMonthsAgo);
      setTdate(today);
      const formData = {
        fdate: threeMonthsAgo.format("YYYY-MM-DD"),
        tdate: today.format("YYYY-MM-DD"),
        src:"back_office"
      };
    const payload ={data :formData}
     
        fetchRequests(payload);
    }, []);
   const fetchRequests = async (payload) => {
            try {
                // http://localhost:5000/fno/request-list
                console.log("1",`${backendHosts.REG}${apiUrl.reqList}`)
              const res = await axios.post(`${backendHosts.REG}/fno/request-list`,payload);
                console.log("2",res)
                setRequests(res.data.data.data || []);
            } catch (err) {
                console.error("Failed to fetch FNO list:", err);
            }
        };


    const handleEditClick = (row) => {
        setSelectedRow(row);
        setOpen(true);
        console.log("roww",row)
    };

    const handleClose = () => {
        setOpen(false);
        setSelectedRow(null);
    };

    const handleStatusChangeDropDown = (e) => {
    setStatus(e.target.value)
  }

   const handleFDate = useCallback((newValue) => {
      setFdate(dayjs(newValue).format('YYYY-MM-DD'))
    }, [])
  
  const handleTDate = useCallback((newValue) => {
    if (!newValue) return; // in case user clears the date
    setTdate(newValue); // store as dayjs object
  }, []);


    const handleReset = async () => {

      
        setStatus("Pending")
        setFTError("")
        setPaginationModel({
            pageSize: 10,
            page: 0,
        })
      const today = dayjs();
      const threeMonthsAgo = today.subtract(3, 'month').startOf('month');

      setFdate(threeMonthsAgo);
      setTdate(today);
      const formData = {
        fdate: threeMonthsAgo.format("YYYY-MM-DD"),
        tdate: today.format("YYYY-MM-DD"),
      };
        const payload = { data: formData }
        await fetchRequests(payload)
    }

 
  const handleFormSubmit = async (e) => {
    e.preventDefault()
    if (Fdate === null || Tdate === null) {
      setFTError("Both From Date and To Date required *")
      return
    }
    const formData = { fdate: dayjs(Fdate).format('YYYY-MM-DD'), tdate: dayjs(Tdate).format('YYYY-MM-DD') }
    const payload ={data :formData}
    console.log(payload)
    await fetchRequests(payload)
    setFTError("")
    setStatus("Pending")
    setPaginationModel({
      pageSize: 10,
      page: 0,
    })
  }

   const filteredData = requests.filter((item) => item.status === status)

    const downloadDocument = async(record)=>{
          // setLoader(true)
          // let filename = phone + "_" + aadhar + "_" + year + "_" + path + ".pdf";
        let payload = {
            data: {
                email: record.emailid,
                status: record.status,
                imageName: record.file_name

            }
        }

          console.log(payload)
      console.log(`${backendHosts.REG}${apiUrl.dwnldPdf}`)
      const result = await axios.post(`${backendHosts.REG}${apiUrl.dwnldPdf}`,payload)
        console.log(result)
        //   const downloadData = await httpRequest({
        //       endPoint: `${backendHosts.ADMIN}${apiUrl.aa}`,
        //       method: "post",
        //       instance: "instanceOne",
        //       requestBody:payload
        //   }) 
          
        //   console.log(downloadData)
          if(result.status === 200) {
         
                  downloadPDF(result.data.data.base64, record.file_name)
                  // setLoader(false)
 
          }else{
         
        
              console.log('Error in AA API')
          }
          
      }

      const downloadPDF = (pdf, filename) => {
        const linkSource = `data:application/pdf;base64,${pdf}`;
        const downloadLink = document.createElement("a");
        const fileName1 = filename
        downloadLink.href = linkSource;
        downloadLink.download = fileName1
        downloadLink.click();
    }

  const handleSave = async (record) => {
    console.log(record)
    const payload = {
      "data": {
        "emailid": record.emailid,
        "verified_by": username,
        "remarks": record.remark
      }
    }
    if (record.status === 'Approved') {
      const result = await axios.post(`${backendHosts.REG}${apiUrl.fnoApprove}`, payload)
      console.log('fno approve res', result)
      if (result.data.data.message === 'F&O request approved successfully') {


        Swal.fire({
          html: `<h2 style="font-size: 24px; font-family: 'cardiuma-regular' !important;">
    Updated Successfully!
</h2>`,
          icon: "success",
          willOpen: () => {
            const swalContainer = document.querySelector(".swal2-container");
            if (swalContainer) {
              swalContainer.style.zIndex = "2000";
            }
          },
        });
        const today = new Date();
        const threeMonthsAgo = new Date(today);
        threeMonthsAgo.setMonth(today.getMonth() - 3);
        threeMonthsAgo.setDate(1);



        const fdate = threeMonthsAgo.toISOString().split("T")[0];
        const tdate = today.toISOString().split("T")[0];

        const formData = { fdate, tdate }
        const payload = { data: formData }

        fetchRequests(payload)
        handleClose()
      }
    }
    if (record.status === 'Rejected') {
      const result = await axios.post(`${backendHosts.REG}${apiUrl.fnoReject}`, payload)
      console.log('fno approve res', result)
      if (result.data.data.message === 'F&O request Rejected successfully') {


        Swal.fire({
          html: `<h2 style="font-size: 24px; font-family: 'cardiuma-regular' !important;">
    Updated Successfully!
</h2>`,
          icon: "success",
          willOpen: () => {
            const swalContainer = document.querySelector(".swal2-container");
            if (swalContainer) {
              swalContainer.style.zIndex = "2000";
            }
          },
        });
        const today = new Date();
        const threeMonthsAgo = new Date(today);
        threeMonthsAgo.setMonth(today.getMonth() - 3);
        threeMonthsAgo.setDate(1);



        const fdate = threeMonthsAgo.toISOString().split("T")[0];
        const tdate = today.toISOString().split("T")[0];

        const formData = { fdate, tdate }
        const payload = { data: formData }

        fetchRequests(payload)
        handleClose()
      }
    }
  }

    // Map your data for DataGrid
    const columns = [
        { field: 'id', headerName: 'ID', width: 70 },
        { field: 'client_id', headerName: 'Client ID', width: 130 },
        { field: 'status', headerName: 'Status', width: 120 },
        { field: 'createdon', headerName: 'Requested On', width: 160 },
        { field: 'emailid', headerName: 'Email', width: 240 },
        { field: 'approvedby', headerName: 'Action By', width: 140 },
        { field: 'approvedon', headerName: 'Action On', width: 240 },
        { field: 'remark', headerName: 'Remark', width: 200 },
        {
            field: 'edit',
            headerName: 'Edit',
            width: 100,
            renderCell: (params) => (
                <Button size="small" onClick={() =>{
                 handleEditClick(params.row)}
                }>
                   <EditIcon />
                </Button>
            ),
        },
    ];

  const handleCopy = (password) => {
    navigator.clipboard.writeText(password);
  };


  return (
    <>
       <div sx={{ margin: '1% 1% 1% 0%' }}>
       <form className={classes.fnoFormDateField} onSubmit={handleFormSubmit}>
          <LocalizationProvider dateAdapter={AdapterDayjs}>
            <span className={classes.datePickerWrapper}>
              <DatePicker
                label="From"
                format="DD-MM-YYYY"
                variant="outlined"
                InputLabelProps={{ shrink: true }}
                InputProps={{ className: classes.input }}
                className={classes.datePicker}
                value={Fdate}
                onChange={(newValue) => { handleFDate(newValue) }}

              />
            </span><br></br>

            <span
              className={classes.datePickerWrapper}
            >
              <DatePicker
                label="To"
                format="DD-MM-YYYY"
                variant="outlined"
                InputLabelProps={{ shrink: true }}
                InputProps={{ className: classes.input }}
                className={classes.datePicker}
                value={Tdate}
                onChange={(newValue) => { handleTDate(newValue) }}
              />
            </span>

          </LocalizationProvider>

          <Button type="submit" sx={{
            width: '100px',
            height: '34px',
            margin: '4px 0 1px 12px',
            color: '#fff',
            backgroundColor: '#F44748',
            fontFamily: 'cardiuma-regular',
            fontSize: '11px',
            fontStyle: 'normal',
            marginRight: 2
          }}>Submit</Button>

          <Button onClick={handleReset} sx={{
            width: '100px',
            height: '34px',
            margin: '4px 0 1px 12px',
            color: '#fff',
            backgroundColor: '#F44748',
            fontFamily: 'cardiuma-regular',
            fontSize: '11px',
            fontStyle: 'normal',
        
          }}>Reset</Button>

        
          <Grid style={{ marginLeft: "20px", borderRadius: "5px"}} >
            <FormControl size="small" style={{ width: "100%" }}>
              <InputLabel  className={classes.inputColorfno} id="demo-select-small-label">
                Status
              </InputLabel>
              <Select
                className={classes.selectfno}
                labelId="demo-select-small-label"
                id="demo-select-small"
                value={status}
                label="Select"
                onChange={(newValue) => { handleStatusChangeDropDown(newValue) }}
                displayEmpty
                MenuProps={{
                  PaperProps: {
                    style: {
                      top: '50px', // Control where dropdown will appear
                    },
                  },
                }}
                sx={{
                  height: '40px',
                  ".css-hfutr2-MuiSvgIcon-root-MuiSelect-icon": {
                    color: "white !important"
                  }
                }}
              >
                <MenuItem className={classes.intSelText} value="Pending">
                  Pending
                </MenuItem>
                <MenuItem className={classes.intSelText} value="Approved">
                  Approved
                </MenuItem>
                <MenuItem className={classes.intSelText}  value="Rejected">
                  Rejected
                </MenuItem>
               

              </Select>
            </FormControl>
          </Grid>

        </form>
      </div>
        {fterror && <Typography color="error" mb={1} ml={2}>{fterror}</Typography>}

      
         <Paper
            className={classes.horizantalTablayout}
            sx={{ height: "80vh" }}
          >
            <DataGrid
              rows={filteredData}
              columns={columns}
              paginationModel={paginationModel}
              onPaginationModelChange={setPaginationModel}
              pageSizeOptions={[10, 25, 50]}
              className={classes.customDataGrid}
              sx={{
                "--DataGrid-containerBackground": "#131E2E",
                "--DataGrid-rowBorderColor": "#000",
                border: 0,
                width: "100% !important",
              }}
              pagination
              getRowId={(row) => row.id}
            />
          </Paper>

      {/* MODAL DIALOG */}
      <Modal open={open} onClose={handleClose}
       aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description">
              <Box 
              sx={{
                  position: "absolute",
                  top: "50%",
                  left: "50%",
                  transform: "translate(-50%, -50%)",
                  width: 500,
                  bgcolor: "background.paper",
                  borderRadius: 2,
                  boxShadow: 24,
                  p: 4,
              }}
        
              >
      <Box sx={{ display: "flex", justifyContent: "center", alignItems: "center", mb: 4 }}>
      <Typography variant="h6" fontWeight="bold">
        F&O Details
      </Typography>
      
    </Box>
    {/* <CloseIcon
        onClick={handleClose}
        sx={{ cursor: "pointer", color: "red", fontSize: "20px" }}
      /> */}

    {selectedRow && (
     
         
              <>
              <Box sx={{ display: "flex", justifyContent: "space-between", my: 1 }}>
                <Typography fontWeight="cardiuma-SemiBold">ClientId:</Typography>
                <Typography>{selectedRow.client_id}</Typography>
              </Box>

              <Box sx={{ display: "flex", justifyContent: "space-between", my: 1 }}>
                <Typography fontWeight="cardiuma-SemiBold">Email:</Typography>
                <Typography>{selectedRow.emailid}</Typography>
              </Box>

              <Box sx={{ display: "flex", justifyContent: "space-between", my: 1 }}>
                <Typography fontWeight="cardiuma-SemiBold">Request Date:</Typography>
                <Typography>{selectedRow.createdon}</Typography>
              </Box>


              <Box sx={{ display: "flex", justifyContent: "space-between", my: 1 }}>
                <Typography fontWeight="cardiuma-SemiBold">Download document:</Typography>
                <Box onClick={() => downloadDocument(selectedRow)} sx={{ cursor: "pointer" }}>
                  <Download />
                </Box>
              </Box>

              <Box sx={{ display: "flex", justifyContent: "space-between", my: 1 }}>
                <Typography fontWeight="cardiuma-SemiBold">Status:</Typography>
                <Typography>{selectedRow.status}</Typography>
              </Box>
              { selectedRow.status === "Rejected" && status == 'Pending' && (
                <Box sx={{ display: "flex", justifyContent: "space-between", my: 1 }}>
                  <Typography fontWeight="cardiuma-SemiBold">Remark:</Typography>
                  <TextField
                    size="small"
                    fullWidth
                    multiline
                    maxRows={3}
                    value={selectedRow.remark || ""}
                    onChange={(e) =>
                      setSelectedRow({ ...selectedRow, remark: e.target.value })
                    }
                    placeholder="Enter remark"
                    sx={{ ml: 2 }}
                  />
                </Box>
              )}


              {selectedRow.password &&
                <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "center", my: 1 }}>
                  <Typography fontWeight="cardiuma-SemiBold">Password:</Typography>
                  <Box sx={{ display: "flex", alignItems: "center" }}>
                    <Typography sx={{ mr: 1 }}>{selectedRow.password}</Typography>
                    <Tooltip title="Copy" arrow>
                      <IconButton onClick={handleCopy(selectedRow.password)} size="small">
                        <ContentCopyIcon fontSize="small" sx={{ color:"#42a0f7"}}/>
                      </IconButton>
                    </Tooltip>
                  </Box>
                </Box>
               }

              {/* ✅ Show checklist only when Approved */}
              {selectedRow.status === "Approved" && (
                <Box sx={{ my: 2 }}>
                  <Typography fontWeight="cardiuma-SemiBold" sx={{ mb: 1 }}>
                    Checklist:
                  </Typography>

                  <Box sx={{ display: "flex", flexDirection: "column"}}>
                    <FormControlLabel
                      control={
                        <Checkbox
                          checked={selectedRow.checklist?.ucc || false}
                          onChange={(e) =>
                            setSelectedRow({
                              ...selectedRow,
                              checklist: { ...selectedRow.checklist, ucc: e.target.checked },
                            })
                          }
                        />
                      }
                      label="UCC"
                    />

                    <FormControlLabel
                      control={
                        <Checkbox
                          checked={selectedRow.checklist?.techexecl || false}
                          onChange={(e) =>
                            setSelectedRow({
                              ...selectedRow,
                              checklist: { ...selectedRow.checklist, techexecl: e.target.checked },
                            })
                          }
                        />
                      }
                      label="TechExcel"
                    />

                    <FormControlLabel
                      control={
                        <Checkbox
                          checked={selectedRow.checklist?.xts || false}
                          onChange={(e) =>
                            setSelectedRow({
                              ...selectedRow,
                              checklist: { ...selectedRow.checklist, xts: e.target.checked },
                            })
                          }
                        />
                      }
                      label="XTS"
                    />
                  </Box>
                </Box>
              )}

              {/* ✅ Change Status dropdown only when Pending */}
              {status === "Pending" && (
                <Box sx={{ display: "flex", justifyContent: "space-between", my: 2 }}>
                  <Typography fontWeight="cardiuma-SemiBold">Change status:</Typography>
                  <TextField
                    select
                    size="small"
                    value={selectedRow.status}
                    onChange={(e) => setSelectedRow({ ...selectedRow, status: e.target.value })}
                    sx={{ width: 150 }}
                    SelectProps={{ native: true }}
                  >
                    <option value="Pending">Pending</option>
                    <option value="Approved">Approved</option>
                    <option value="Rejected">Rejected</option>
                  </TextField>
                </Box>
              )}

              {/* ✅ Save button logic */}
              {
                status == 'Pending' && 
                <Box sx={{ display: "flex", justifyContent: "flex-end", mt: 3 }}>
                  <Button
                    variant="contained"
                    sx={{ backgroundColor: "#f44", color: "#fff" }}
                    onClick={() => handleSave(selectedRow)}
                    disabled={
                      (selectedRow.status === "Pending") ||
                      (selectedRow.status === "Approved" &&
                        !(
                          selectedRow.checklist?.ucc &&
                          selectedRow.checklist?.techexecl &&
                          selectedRow.checklist?.xts
                        )) || 
                      (selectedRow.status === "Rejected" && !selectedRow.remark?.trim())
                    }
                  >
                    SAVE
                  </Button>
                </Box>
              }
              </>
        
    )}

     </Box>
      </Modal>
    </>
  );
};

export default withStyles(styles)(Fno);
